/* eslint-disable jsx-a11y/anchor-has-content */
import React, { Component } from 'react'
import ReactDOM from 'react-dom'

export default class Cookie extends Component {
  state = {
    content: ''
  }
  handleClose = () => {
    window.localStorage.setItem('master-cookie', 'true')
    this.setState({ content: '' })
  }
  componentDidMount() {
    const hasSeen = window.localStorage.getItem('master-cookie')
    const cookieContent = document.getElementById('cookie-consent-content')
      .innerHTML
    this.setState({ content: !hasSeen ? cookieContent : '' })
  }
  render() {
    return (
      <div
        className="cookie-consent"
        style={this.state.content !== '' ? {} : { display: 'none' }}
      >
        <div className="close" onClick={this.handleClose} />
        {this.state.content !== '' ? (
          <div
            className="content"
            dangerouslySetInnerHTML={{
              __html: this.state.content
            }}
          />
        ) : (
          ''
        )}
      </div>
    )
  }
}

ReactDOM.render(<Cookie />, document.querySelector('#cookie-consent'))
